import React from 'react'

export const ApplicationList = ({customer_applications = [], getApplicationItemLayout, t, RenderComponent}) => {
  if(!customer_applications.length) return null
  const listingType = customer_applications[0].status
  return(
    <section styleName={`card-inset`}>
      <h2 styleName="card-inset__header heading heading--large">{t(`customer_applications.listing.${listingType}`)}</h2>
      {customer_applications.map((app, idx) => <RenderComponent id={app.id} key={idx} layout={getApplicationItemLayout(app)} />)}
    </section>
  )
}
